<template lang="pug">
  transition-group.animal-list(v-on:enter="enter" name='fade' tag='ul')
    AnimalItem(v-for="animal in animalList" :key="animal.id" :animal="animal")
</template>

<script>
import AnimalItem from '@/components/AnimalItem.vue'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      animalList: this.$store.state.animalList
    }
  },
  methods: {
    ...mapActions([
      'incrementCurrentNum',
      'removeAnimal',
      'decrementCurrentNum',
    ]),
    enter: function () {
      this.incrementCurrentNum()
      setTimeout(this.remove, this.$store.state.animalLifetime)
    },
    remove: function () {
      this.removeAnimal()
      this.decrementCurrentNum()
    },
  },
  components: {
    AnimalItem
  }
}
</script>

<style lang="stylus" scoped>
.animal-list
  width 100%
  flex auto

ul
  list-style none
  padding 0
  margin 0

.fade {
  &-enter {
    &-active {
      opacity 0
      transform translate3d(-90%, 0, 0)
    }
    &-to {
      opacity 1
      transform translate3d(0, 0, 0)
    }
  }
}
</style>